import styled from "@emotion/styled";
import { Flex, Text } from "styles/utility-components";

import Button from "components/ui/button/Button";
import Modal from "components/ui/modal/Modal";
import toast from "components/ui/toast/Toast";
import { AiToneOfVoice } from "lib/hooks/api/ai_tone_of_voice/useAiToneOfVoices";
import { EventNames, useTracking } from "lib/tracking";
import { useDeleteAiToneOfVoice } from "../../../lib/hooks/api/ai_tone_of_voice/useDeleteAiToneOfVoice";

type Props = {
  open: boolean;
  onClose: () => void;
  entry: AiToneOfVoice;
};

const BODY_ID = "delete-tov-modal-body";

export function DeleteToneOfVoiceModal({ open, onClose, entry }: Props): JSX.Element {
  const { logEvent } = useTracking();
  const { mutate: deleteToneOfVoice, isLoading: isDeleting } = useDeleteAiToneOfVoice({
    onSuccess: () => {
      logEvent(EventNames.toneOfVoiceGuideDeleted, { "Context source": "Manual" });
      toast.success("Tone of voice deleted");
      onClose();
    },
    onError: () => {
      toast.error("Failed to delete tone of voice");
    },
  });

  return (
    <Modal
      open={open}
      onOpenChange={onClose}
      maxWidth="400px"
      showCloseButton={false}
      aria-describedby={BODY_ID}
    >
      <Container column gap={24}>
        <Flex column gap={8}>
          <Text h2>Delete tone of voice</Text>
          <Text id={BODY_ID}>Are you sure you want to delete &quot;{entry.label}&quot;?</Text>
        </Flex>
        <ButtonRow justifyContent="flex-end" gap={8}>
          <Button buttonStyle="inverse" onClick={onClose} disabled={isDeleting}>
            Cancel
          </Button>
          <Button
            buttonStyle="destructive"
            onClick={() => deleteToneOfVoice({ id: entry.id })}
            disabled={isDeleting}
            loading={isDeleting}
          >
            Delete
          </Button>
        </ButtonRow>
      </Container>
    </Modal>
  );
}

const Container = styled(Flex)({
  padding: 24,
});

const ButtonRow = styled(Flex)({});
